// Cross-browser XMLHttpRequest object
(function () {
    function createRequestObject() {
        let ro = false;

        if (window.ActiveXObject) {
        // We probably don't need to support this anymore
            ro = new ActiveXObject('Microsoft.XMLHTTP');
        } else if (window.XMLHttpRequest) {
            ro = new XMLHttpRequest();
            ro.overrideMimeType('text/xml');
        }
        return ro;
    }

    // These are referenced from some other JSPs and JS
    window.reqObj = createRequestObject();

    window.sendReq = function (url, handleResponse) {
        if (reqObj) {
            let tsSep = '&';
            if (url.indexOf('?') == -1) {
                tsSep = '?';
            }
            reqObj.open('get', url + tsSep + 'timestamp=' + (+new Date()));
            reqObj.onreadystatechange = handleResponse;
            reqObj.send(null);
        }
    };
})();
